import PlayIcon from './states/Play'
import PlusIcon from './states/Plus'
import PauseIcon from './states/Pause'
import RestartIcon from './states/Restart'
import LoadingIcon from './states/Loading'
import NextIcon from './states/Next'
import PreviousIcon from './states/Previous'
import ForwardIcon from './states/Forward'
import BackwardsIcon from './states/Backwards'
import InfoIcon from './states/Info'
import CloseIcon from './states/Close'
import ClockIcon from './states/Clock'
import CalendarIcon from './states/Calendar'
import LinkIcon from './states/Link'
import ChapterIcon from './states/Chapter'
import DownloadIcon from './states/Download'
import AudioFileIcon from './states/AudioFile'
import ImageFileIcon from './states/ImageFile'
import PdfFileIcon from './states/PdfFile'
import TextFileIcon from './states/TextFile'
import VideoFileIcon from './states/VideoFile'
import EmbedIcon from './states/Embed'
import TwitterIcon from './states/Twitter'
import RedditIcon from './states/Reddit'
import PinterestIcon from './states/Pinterest'
import MailIcon from './states/Mail'
import LinkedinIcon from './states/Linkedin'
import FacebookIcon from './states/Facebook'
import ContentShowIcon from './states/ContentShow'
import ContentPlaytimeIcon from './states/ContentPlaytime'
import ContentChapterIcon from './states/ContentChapter'
import ContentEpisodeIcon from './states/ContentEpisode'
import ShareIcon from './states/Share'
import CopyIcon from './states/Copy'
import Speaker0Icon from './states/Speaker0'
import Speaker25Icon from './states/Speaker25'
import Speaker50Icon from './states/Speaker50'
import Speaker75Icon from './states/Speaker75'
import PodloveIcon from './states/Podlove'
import PodlovePlayerIcon from './states/PodlovePlayer'
import TranscriptsIcon from './states/Transcripts'
import SearchClearIcon from './states/SearchClear'
import SearchNextIcon from './states/SearchNext'
import SearchPreviousIcon from './states/SearchPrevious'
import MissingConnectionIcon from './states/MissingConnection'
import InvalidConfigurationIcon from './states/InvalidConfiguration'
import SubscribeIcon from './states/Subscribe'
import ArrowToRightIcon from './states/ArrowToRight'
import ArrowToLeftIcon from './states/ArrowToLeft'
import Speed050Icon from './states/Speed050'
import Speed075Icon from './states/Speed075'
import Speed100Icon from './states/Speed100'
import Speed125Icon from './states/Speed125'
import Speed150Icon from './states/Speed150'
import Speed175Icon from './states/Speed175'
import Speed200Icon from './states/Speed200'
import ActiveTabIcon from './states/ActiveTab'
import PlaylistIcon from './states/Playlist'
import SearchIcon from './states/Search'
import MenuPlayIcon from './states/MenuPlay'
import MenuPauseIcon from './states/MenuPause'
import MenuEmptyIcon from './states/MenuEmpty'
import MessengerIcon from './states/Messenger'
import CheckMarkIcon from './states/CheckMark'
import ChevronRightIcon from './states/ChevronRight'
import ChevronLeftIcon from './states/ChevronLeft'
import XingIcon from './states/Xing'
import WhatsAppIcon from './states/WhatsApp'

export const types = [
  'play',
  'plus',
  'pause',
  'loading',
  'restart',
  'loading',
  'next',
  'previous',
  'forward',
  'backwards',
  'info',
  'close',
  'clock',
  'calendar',
  'link',
  'chapter',
  'download',
  'audio-file',
  'image-file',
  'pdf-file',
  'text-file',
  'video-file',
  'embed',
  'twitter',
  'reddit',
  'pinterest',
  'mail',
  'linkedin',
  'facebook',
  'content-show',
  'content-playtime',
  'content-chapter',
  'content-episode',
  'share',
  'copy',
  'speaker-0',
  'speaker-25',
  'speaker-50',
  'speaker-75',
  'podlove',
  'podlove-player',
  'transcripts',
  'search-clear',
  'search-previous',
  'search-next',
  'missing-connection',
  'invalid-configuration',
  'subscribe',
  'arrow-to-right',
  'arrow-to-left',
  'speed-050',
  'speed-075',
  'speed-100',
  'speed-125',
  'speed-150',
  'speed-175',
  'speed-200',
  'active-tab',
  'playlist',
  'search',
  'menu-play',
  'menu-pause',
  'menu-empty',
  'messenger',
  'check-mark',
  'chevron-left',
  'chevron-right',
  'whats-app',
  'xing'
]

export const components = {
  PlayIcon,
  PlusIcon,
  PauseIcon,
  RestartIcon,
  LoadingIcon,
  NextIcon,
  PreviousIcon,
  ForwardIcon,
  BackwardsIcon,
  InfoIcon,
  CloseIcon,
  ClockIcon,
  CalendarIcon,
  LinkIcon,
  ChapterIcon,
  DownloadIcon,
  AudioFileIcon,
  ImageFileIcon,
  PdfFileIcon,
  TextFileIcon,
  VideoFileIcon,
  EmbedIcon,
  TwitterIcon,
  RedditIcon,
  PinterestIcon,
  MailIcon,
  LinkedinIcon,
  FacebookIcon,
  ContentShowIcon,
  ContentPlaytimeIcon,
  ContentChapterIcon,
  ContentEpisodeIcon,
  ShareIcon,
  CopyIcon,
  Speaker0Icon,
  Speaker25Icon,
  Speaker50Icon,
  Speaker75Icon,
  PodloveIcon,
  PodlovePlayerIcon,
  TranscriptsIcon,
  SearchClearIcon,
  SearchNextIcon,
  SearchPreviousIcon,
  MissingConnectionIcon,
  InvalidConfigurationIcon,
  SubscribeIcon,
  ArrowToRightIcon,
  ArrowToLeftIcon,
  Speed050Icon,
  Speed075Icon,
  Speed100Icon,
  Speed125Icon,
  Speed150Icon,
  Speed175Icon,
  Speed200Icon,
  ActiveTabIcon,
  PlaylistIcon,
  SearchIcon,
  MenuPlayIcon,
  MenuPauseIcon,
  MenuEmptyIcon,
  MessengerIcon,
  CheckMarkIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
  XingIcon,
  WhatsAppIcon
}
